module.exports = __webpack_public_path__ + "static/media/Finnovex-Saudi-Arabia-2024.b1d3452b.png";